
import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Form, FormGroup, Button, FormControl } from 'react-bootstrap'
import { momentHelper } from '../helpers'
import SelectDate from 'component/element/SelectDate'
// import Select from 'react-select'
import PrintButtons from 'component/element/PrintButtons'
import ReportStore from 'stores/ReportStore'
import WorkdocStore from 'stores/WorkdocStore'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import FontAwsome from 'react-fontawesome'
import DatePicker from 'component/element/DatePicker'
import IframeModal from 'component/element/IframeModal'
import Moment from 'moment'
import '../report.css'
// import { connect } from 'react-redux';
const WHOLE_YEAR = momentHelper.getMonth()
const NotificationSystem = require('react-notification-system');
class ReportAnalysisWorkCustomCost extends Component {
  constructor(props) {
    super(props)
    
    this.state = {
      loading:false,
      activePage:1,
      month:WHOLE_YEAR,
      year:momentHelper.getYear(),
      data:[],
      custom_cost_field:[],
      isRange: false,
      day:'00',
      dayRange:momentHelper.getDay(),
      monthRange:WHOLE_YEAR,
      yearRange:momentHelper.getYear(),
      showDetail:false,
      isSubMenu:false,
      subMenu:[],
      type:'',
      payment_type:''
    }
    this.refTableId = 'ReportAnalysisWorkCustomCost-'+Math.ceil(Math.random()*100);
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem
    if(this.props.show && (this.props.show==true ||this.props.show==='true')){
      this.loadInsureStat(this.state.year,this.state.month,this.state.day)
    }
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadInsureStat(this.state.year,this.state.month,this.state.day)
    }
  }

  getAllDayOfMonth(date) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth()
    if (all_day) {
      if (all_day<this.state.day) {
        var defaultDay = '00'
      } else {
        var defaultDay = this.state.day
      }
    } else {
      var defaultDay = '00'
    }
    return defaultDay
}

  getNumberFormat(value,decimal=2) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(decimal).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getSummary(field) {
    let {data} = this.state
    let total = 0
    data.forEach((item,index)=> {
        total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
    }) 
    return total
  }

  loadInsureStat(year='',month='',day='') {
    ReportStore.loadAnalysisWorkCustomCost(year,month,day,(result)=>{
      this.setState({loading:false,data:result.data,custom_cost_field:result.custom_cost_field})
    })
  }

  loadInsureStatRange(start='',end='') {
    ReportStore.loadAnalysisWorkCustomCostRange(start,end,(result)=>{
      this.setState({loading:false,data:result.data,custom_cost_field:result.custom_cost_field})
    })
  }

  onDayChange(val){
    this.setState({
      day: val.value, isRange:false
    })
    this.loadInsureStat(this.state.year,this.state.month,val.value)
  }

  onMonthChange(val) {
    let date = this.state.year-543+'-'+val.value
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      month: val.value, isRange: false, day:_day
    })
    this.loadInsureStat(this.state.year,val.value,_day)
  }

  onYearChange(val) {
    let date = val.value-543+'-'+this.state.month
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      year: val.value, isRange: false, day:_day
    })
    this.loadInsureStat(val.value,this.state.month,_day)
  }

  onPrintTable(e) {
    const {isRange} = this.state
    let url = ''
    let param = 'PrintReportAnalysisWorkCustomCost&year='+this.state.year+'&month='+this.state.month+'&day='+this.state.day+'&isRange=false'
    if (isRange) {
        let {day,month,year,dayRange,monthRange,yearRange} = this.state
        let start = day+'/'+(month=='00'?'1':month)+'/'+(year-543)
        let end = dayRange+'/'+monthRange+'/'+(yearRange-543)
        param = 'PrintReportAnalysisWorkCustomCost&start_date='+start+'&end_date='+end+'&isRange=true'
    }    

    if (process.env.NODE_ENV == "development") {
      url  = './?startPage='+param
    } else{
      url = './pdf/v2/?startPage='+param
    }
    this.refs.iframe.loadUrl(url)
  }

  onExportExcel(e) {
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }    
    const fileName = 'รายงานต้นทุน.xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName) 
    this.setState({showExport:false})
  }

  onStartDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let _day = time.substr(0,2)
      let _month = time.substr(3,2)
      let _year = time.substr(6,10)
      this.setState({day:_day*1,month:_month,year:_year*1,isRange:false})
      this.loadInsureStat(_year,_month,_day)
    }
  }

  onEndDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let {day,month,year} = this.state
      let _day = parseInt(time.substr(0,2))
      let _month = parseInt(time.substr(3,5))
      let _year = parseInt(time.substr(6,10))
      this.setState({isRange:true,dayRange:_day,monthRange:_month,yearRange:_year})
      year = year - 543
      _year = _year - 543
      let start = day+'/'+(month=='00'?'1':month)+'/'+year
      let end = _day+'/'+_month+'/'+_year
      this.loadInsureStatRange(start,end)
    }  
  }

  onRangeChange(fromDateString,toDateString,items) {
    let {day,month,year,dayRange,monthRange,yearRange} = this.state
    day = items.from.format('DD')*1
    month = items.from.format('MM')
    year = (items.from.format('YYYY')*1)+543
    dayRange = items.to.format('DD')*1
    monthRange = items.to.format('MM')
    yearRange = (items.to.format('YYYY')*1)+543
    this.setState({isRange:true,day:day,month:month,year:year,dayRange:dayRange,monthRange:monthRange,yearRange:yearRange})
    const start = day+'/'+month+'/'+items.from.format('YYYY')
    const end = dayRange+'/'+monthRange+'/'+items.to.format('YYYY')
    this.loadInsureStatRange(start,end)
  }

  renderWCalendar() {
    return(
      <div style={{display:'inline-flex'}}>
        <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={(this.state.day=='00'?momentHelper.getDay():this.state.day)+'/'+(this.state.month=='00'?WHOLE_YEAR:this.state.month)+'/'+this.state.year}
                onChange={this.onStartDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
          <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={(this.state.dayRange=='00'?momentHelper.getDay():this.state.dayRange)+'/'+(this.state.monthRange=='00'?WHOLE_YEAR:this.state.monthRange)+'/'+this.state.yearRange}
                onChange={this.onEndDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
      </div>
    )
  }

  renderToolbar() {
    return(
      <Form inline style={{marginBottom:'5px'}}>
        <FormGroup style={{verticalAlign:'top'}}>
          <SelectDate
            wholeYear={true}
            year={this.state.year}
            month={this.state.month}
            day={this.state.day}
            onMonthChange={this.onMonthChange.bind(this)}
            onYearChange={this.onYearChange.bind(this)}
            onDayChange={this.onDayChange.bind(this)}
            dayWCalendar={true}
            renderWCalendar={this.renderWCalendar.bind(this)}
          />
        </FormGroup>  
        {' '}
        <FormGroup style={{verticalAlign:'top'}}>
          <PrintButtons
            onPrintTable={this.onPrintTable.bind(this)}
            onExportExcel={this.onExportExcel.bind(this)}
            marginLeft='0'
            width='auto'
          />
        </FormGroup>
      </Form>
    )
  }

  getStartDateRangeText() {
    let {day,month,year} = this.state
    let txtMonth = momentHelper.getMonthText(month.toString())
    return day*1+' '+ txtMonth +' '+ year
  }

  getEndDateRangeText() {
    let {dayRange,monthRange,yearRange} = this.state
    dayRange = dayRange==0?1:dayRange
    let txtMonth = momentHelper.getMonthText(monthRange.toString())
    return dayRange +' '+ txtMonth +' '+ yearRange
  }

  onRangeClearClick() {
    this.loadInsureStat(this.state.year,this.state.month,this.state.day)
    this.setState({isRange:false,dayRange:momentHelper.getDay(),monthRange:this.state.month,yearRange:this.state.year})
  }

  renderDateRange() {
    let {isRange} = this.state
    if (isRange) {
      return(
        <div style={{marginBottom:'10px',display:'flex'}}>
          {this.getStartDateRangeText()} - {this.getEndDateRangeText()}&nbsp;<Button className='btn btn-xs' onClick={this.onRangeClearClick.bind(this)}><FontAwsome name='eraser' />&nbsp;ลบช่วงเวลา</Button>
        </div>
      )
    } else {
      return('')
    }  
  }

  onFormChange(index,sindex,field,e) {
    let {data} = this.state
    data[index][field] = e.target.value
    this.setState({data:data})
  }

  onFormBlur(index,sindex,field,e) {
    let {data} = this.state
    let postData = data[index]
    WorkdocStore.saveReportCustomCost(postData,(result)=>{
      if (result.status==='OK') {
        this._notificationSystem.addNotification({
          title:'แจ้งเตือน',
          message:'บันทึกรายการสำเร็จ',
          level:'info',
          position:'tc'        
        });
      }
    },()=>{

    })
  }

  renderRowData() {
    let {data,custom_cost_field} = this.state
    if (data.length==0) {
      return(<tr><td colSpan={10+custom_cost_field.length}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        data.map((item,index)=>{
          return(
            <tr key={index}>
              <td className='text-center'>{index+1}</td>
              <td className='text-center'>{item.work_no}</td>
              <td className='text-center'>{item.brand}</td>
              <td className='text-center'>{item.car_registration_no}</td>
              <td className='text-center'>{item.insurer_name}</td>
              <td className='text-center'>{item.vip_member}</td>
              <td className='text-center'>{item.damage_major_quantity}</td>
              <td className='text-center'>{item.damage_minor_quantity}</td>
              <td className='text-right'>{this.getNumberFormat(item.approved_wage)}</td>
              <td className='text-right'>{this.getNumberFormat(item.approved_part)}</td>
              {custom_cost_field.map((sitem,sindex)=>{
                return(
                  <td className='text-right' key={index+'-'+sindex}>
                    <FormControl onBlur={this.onFormBlur.bind(this,index,sindex,sitem.field)} onChange={this.onFormChange.bind(this,index,sindex,sitem.field)} className='text-right' value={item[sitem.field]} />
                  </td>
                )
              })}
            </tr>
          )
        })
      )
    }
  }

  renderExcelRowData() {
    let {data,custom_cost_field} = this.state
    if (data.length==0) {
      return(<tr><td colSpan={10+custom_cost_field.length}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        data.map((item,index)=>{
          return(
            <tr key={index}>
              <td className='text-center'>{index+1}</td>
              <td className='text-center'>{item.work_no}</td>
              <td className='text-center'>{item.brand}</td>
              <td className='text-center'>{item.car_registration_no}</td>
              <td className='text-center'>{item.insurer_name}</td>
              <td className='text-center'>{item.vip_member}</td>
              <td className='text-center'>{item.damage_major_quantity}</td>
              <td className='text-center'>{item.damage_minor_quantity}</td>
              <td className='text-right'>{this.getNumberFormat(item.approved_wage)}</td>
              <td className='text-right'>{this.getNumberFormat(item.approved_part)}</td>
              {custom_cost_field.map((sitem,sindex)=>{
                return(
                  <td className='text-right' key={index+'-'+sindex}>
                    {this.getNumberFormat(item[sitem.field])}
                  </td>
                )
              })}
            </tr>
          )
        })
      )
    }
  }

  getDate() {
    let {day,year,month,isRange,dayRange,monthRange,yearRange} = this.state
    if (isRange) {
      let start = (day<10?'0'+day:day)+'/'+(month=='00'?'1':month)+'/'+(year-543)
      let end = dayRange+'/'+(monthRange<10?'0'+monthRange:monthRange)+'/'+(yearRange-543)
      return 'ประจำวันที่ '+start+' - '+end
    } else {
      let text = 'ประจำวันที่ '
      text += day+' '+momentHelper.getMonthText(month)+' '+(year-543)
      if (year==='0'||year==='00'||year===0) {
        text = 'ทั้งหมด'
      } else if (month==='0'||month==='00'||month===0) {
        text = 'ประจำปี '+(year-543)
      } else if (day==='0'||day==='00'||day===0) {
        text = 'ประจำเดือน '+momentHelper.getMonthText(month)+' '+(year-543)
      }
      return text
    }  
  }

  renderTable() {
    let {custom_cost_field} = this.state
    return (
      <div className='table-responsive'>
        <table className='table table-hover table-bordered-solid' style={{minWidth:'1880px'}}>
          <thead>
            <tr>
              <th colSpan={6}></th>
              <th colSpan={2} className='text-center'>จำนวนชิ้นงาน</th>
              <th colSpan={2} className='text-center'>ราคาที่ได้รับ</th>
              <th colSpan={custom_cost_field.length} className='text-center'>ต้นทุน</th>
            </tr>
            <tr>
              <th className='text-center' style={{width:'50px'}}>ลำดับ</th>
              <th className='text-center' style={{width:'120px'}}>Job No.</th>
              <th className='text-center' style={{width:'100px'}}>ยี่ห้อ</th>
              <th className='text-center' style={{width:'110px'}}>ทะเบียน</th>
              <th className='text-center' style={{width:'110px'}}>ประกัน</th>
              <th className='text-center' style={{width:'110px'}}>Member</th>
              <th className='text-center' style={{width:'90px'}}>ชิ้นหลัก</th>
              <th className='text-center' style={{width:'90px'}}>ชิ้นรอง</th>
              <th className='text-center' style={{width:'90px'}}>ค่าแรง</th>
              <th className='text-center' style={{width:'90px'}}>ค่าอะไหล่</th>
              {custom_cost_field.map((item,index)=>{
                return(
                  <th key={index} className='text-center' style={{width:'90px'}}>{item.title}</th>
                )
              })}
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
        </table>
      </div>
    )
  }

  renderExcelTable() {
    let {custom_cost_field} = this.state
    return (
      <div style={{display:'none'}}>
        <table id={this.refTableId} className='table table-responsive table-hover table-bordered-solid'>
          <thead>
            <tr>
              <th colSpan={6}></th>
              <th colSpan={2} className='text-center'>จำนวนชิ้นงาน</th>
              <th colSpan={2} className='text-center'>ราคาที่ได้รับ</th>
              <th colSpan={custom_cost_field.length} className='text-center'>ต้นทุน</th>
            </tr>
            <tr>
              <th className='text-center' style={{width:'50px'}}>ลำดับ</th>
              <th className='text-center' style={{width:'120px'}}>Job No.</th>
              <th className='text-center' style={{width:'100px'}}>ยี่ห้อ</th>
              <th className='text-center' style={{width:'110px'}}>ทะเบียน</th>
              <th className='text-center' style={{width:'110px'}}>ประกัน</th>
              <th className='text-center' style={{width:'110px'}}>Member</th>
              <th className='text-center' style={{width:'90px'}}>ชิ้นหลัก</th>
              <th className='text-center' style={{width:'90px'}}>ชิ้นรอง</th>
              <th className='text-center' style={{width:'90px'}}>ค่าแรง</th>
              <th className='text-center' style={{width:'90px'}}>ค่าอะไหล่</th>
              {custom_cost_field.map((item,index)=>{
                return(
                  <th key={index} className='text-center' style={{width:'90px'}}>{item.title}</th>
                )
              })}
            </tr>
          </thead>
          <tbody>
            {this.renderExcelRowData()}
          </tbody>
        </table>
      </div>
    )
  }

  render() {
    const reportName = 'รายงานต้นทุน'
    const reportDateText = momentHelper.getMonthText(this.state.month) + " " + this.state.year
    const title = reportName + ' ' + reportDateText
    const {loading,showDetail} = this.state
    return (
      <Box loading={loading}>
        <Box.Header border={true}>          
          {this.props.renderMenu()}
        </Box.Header>
        <Box.Body>
          {this.renderToolbar()}
          {this.renderDateRange()}
          {this.renderTable()}
          {this.renderExcelTable()}
          <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
        <NotificationSystem ref="notificationSystem" />
        </Box.Body>
      </Box>
    )
  }
}

ReportAnalysisWorkCustomCost.defaultProps = {
  show:false
}

export default ReportAnalysisWorkCustomCost;





// WEBPACK FOOTER //
// ./src/view/report/analysis/ReportAnalysisWorkCustomCost.js